import CaretRightIcon from 'components/common/IconsV2/CaretRightIcon';
import { useFilteredSortOptions } from 'hooks/useFilteredSortOptions';
import useMartyContext from 'hooks/useMartyContext';
import { filterSortOptions } from 'utils/filterSortOptions';

interface SortSelectProps {
  selectedValue: string | undefined;
  onSortSelected?: React.ChangeEventHandler<HTMLSelectElement>;
  isBestForYouSortEligible: boolean;
}

const SORT_ID = 'searchSort';

const SortSelect = ({ selectedValue, onSortSelected, isBestForYouSortEligible }: SortSelectProps) => {
  const { testId } = useMartyContext();
  const sortOptions = useFilteredSortOptions();
  const options = filterSortOptions(sortOptions, isBestForYouSortEligible);
  return (
    <div className="relative">
      <label htmlFor={SORT_ID} className="sr-only">
        Sort By
      </label>
      <select
        id={SORT_ID}
        className="body-m-subtle h-14 w-56 appearance-none rounded-lg border border-subtle bg-gray-0 p-4 text-tertiary"
        value={selectedValue}
        onChange={onSortSelected}
        data-test-id={testId('selectSortValue')}
      >
        {options.map(({ eventLabel, label, value, ariaLabel }) => (
          <option key={value} value={value} aria-label={ariaLabel || label} data-label={eventLabel || label}>
            {label}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center px-2 text-gray-700">
        <CaretRightIcon className="h-6 w-6 rotate-90" size={32} />
      </div>
    </div>
  );
};

export default SortSelect;
